<template>
  <a @click="selectLanguage" :class="classes">{{ option }}</a>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'tag',
  props: ['option', 'selected'],
  computed: {
    classes() {
      return `ui mini label ${this.option === this.selected && 'active'}`;
    }
  },
  methods: {
    selectLanguage(evt) {
      this.$store.commit('selectLanguage', evt.target.innerText);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tag.vue